<template>
    <div>
        <router-view/>
    </div>
</template>
<!--<template>-->
<!--    <div class="content-wrap">-->
<!--        <div :class="['flexible-content', heightMaxClass]">-->
<!--            <div id="content" class="app-content" role="main">-->
<!--                <router-view/>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</template>-->


<script>
export default {
	mounted(){
	}
}
</script>

<style>

</style>